<div class="c-list__item focus-inwards-dark" [ngClass]="expand? 'c-list__item--expanded' : ''"
     [attr.data-test-id]="'kontakte-mit-kategorien-root '+ (kontakt | testIdFromResource)"
     [draggable]="draggable" (dragstart)="drag($event)">
	<a class="c-list__link" data-test-id="kontakt" (click)="expand = !expand" (keyup.enter)="expand = !expand"
	   [ngClass]="expand? 'c-list__item--expanded' : ''" tabindex="0">
		<div class="c-row c-row--header kontakt-headline" data-test-id="kontakt-headline">
			<span class="c-row__item c-row__item--header">{{ kontakt | nameByKontaktPipe }}</span>
			@if (!kontakt.active) {
				<span class="inactive">(inaktiv)</span>
			}
			<div class="c-button-bar c-button-bar--overlay">
				@if (draggable) {
					<schir-int-client-button-round (click)="assignKontakt()"
					                               toolTip="Kontakt als Adressat hinzufügen"
					                               materialIcon="add"
					                               data-test-id="assign-kontakt"
					                               cssClass="focus-inwards-dark schir-midi-button"/>
				}
				@if (inVerfahren| hasResourceLink: VerfahrenKontaktLinkRel.EDIT_FREITEXT) {
					<schir-int-client-button-round (click)="openVerfahrenKontaktNotizDialog()"
					                               popup="dialog"
					                               toolTip="Notiz hinzufügen"
					                               materialIcon="notes"
					                               data-test-id="open-notiz-dialog-button"
					                               cssClass="focus-inwards-dark schir-midi-button"/>
				}
				@if (inVerfahren| hasResourceLink: VerfahrenKontaktLinkRel.EDIT_FREITEXT) {
					<schir-int-client-button-round (click)="openKontaktAktenzeichenDialog()"
					                               popup="dialog"
					                               toolTip="Aktenzeichen hinzufügen"
					                               materialIcon="topic"
					                               data-test-id="open-aktenzeichen-dialog-button"
					                               cssClass="focus-inwards-dark schir-midi-button"/>
				}
				@if (kontakt | hasResourceLink: KontaktLinkRel.EDIT) {
					<schir-int-client-button-round (click)="openKontaktInAdressverwaltung(kontakt)"
					                               toolTip="Kontaktdaten bearbeiten"
					                               popup="dialog"
					                               materialIcon="edit"
					                               data-test-id="edit-kontakt"
					                               cssClass="focus-inwards-dark schir-midi-button"/>
				}
				<schir-int-client-button-round (click)="openFinanzSanktionsListe()"
				                               toolTip="Aufruf der Finanzsanktionsliste" materialIcon="euro"
				                               data-test-id="link-to-fisalis"
				                               cssClass="focus-inwards-dark schir-midi-button"/>
				<schir-int-client-button-round (click)="copyMailAddressToClipboard(kontakt)"
				                               toolTip="Adressdaten in die Zwischenablage kopieren"
				                               materialIcon="contact_mail" data-test-id="mail-address-button"
				                               cssClass="focus-inwards-dark schir-midi-button"/>
			</div>
		</div>
		<div class="expandable" data-test-id="kontakt-data">
			<p data-test-id="strasse-hausnummer">{{ kontakt.strasse }} {{ kontakt.hausnummer }}</p>
			<p data-test-id="plz-stadt">{{ kontakt.plz }} {{ kontakt.stadt }}</p>
			<p data-test-id="notiz">{{ kontakt.notiz }}</p>
		</div>
		<div class="c-row">
			<span class="c-row__item" data-test-id="firmenName1">{{ kontakt.firmenName1 }}</span>
		</div>
		<div class="c-row">
			<span class="c-row__item" data-test-id="firmenName2">{{ kontakt.firmenName2 }}</span>
		</div>
		@if (inVerfahren.aktenzeichen) {
			<span class="az-and-notiz" data-test-id="verfahrenKontaktAktenzeichen">{{ inVerfahren.aktenzeichen }}</span>
		}
		@if (inVerfahren.notiz) {
			<span class="az-and-notiz" data-test-id="verfahrenKontaktNotiz">{{ inVerfahren.notiz }}</span>
		}
		@for (kategorie of inVerfahren.kategorien; track kategorie) {
			<div class="c-row mt-1" [attr.data-test-id]="'kategorie-container-' + kategorie">
            <span class="c-row__item--multiline kategorie-label"
                  data-test-id="kategorie">{{ kategorie | enumToLabel: kategorieLabel }} <br>
                </span>
				<div class="secondary-button-bar secondary-button-bar--overlay">

					@if (allowsUnassign) {
						<schir-int-client-button-round (click)="unassign(kategorie)"
						                               toolTip="Kontakt aus dem Verfahren löschen"
						                               materialIcon="delete"
						                               data-test-id="unassign-kontakt"
						                               cssClass="focus-inwards-dark schir-midi-button"/>
					}
				</div>
			</div>
		}
	</a>
	<span class="visually-hidden" role="alert">{{ audioAlert | async }}</span>
</div>
